import type {
    PlaylistItemRequest,
    SendItemResultRequest,
    SendStateRequest,
    SendTrackingRequest,
    Client,
} from './index';
import type { Playlist, PlaylistItemContent } from '../playlist';
import env from '../env';

export class ChaosClient {
    client: Client;

    constructor(client: Client) {
        this.client = client;
    }

    async fetchPlaylist(): Promise<Playlist> {
        if (env.chaosNoPlaylist) {
            throw new Error('chaos: loading playlist fails');
        }

        let playlist = await this.client.fetchPlaylist();

        if (env.chaosEmptyPlaylist) {
            playlist.playlist = [];
        }

        if (env.chaosForceSafearea) {
            playlist.display_safearea = true;
        }

        if (env.chaosForceTemplate.length != 0) {
            playlist.template_name = env.chaosForceTemplate;
        }

        return playlist;
    }

    async getContent(props: PlaylistItemRequest): Promise<PlaylistItemContent> {
        if (Math.random() > 1.0 - env.chaosNoContent) {
            throw new Error('chaos: loading content fails');
        }

        return this.client.getContent(props);
    }

    async sendState(req: SendStateRequest): Promise<any> {
        return this.client.sendState(req);
    }

    async sendItemResult(req: SendItemResultRequest): Promise<any> {
        return this.client.sendItemResult(req);
    }

    async sendTracking(req: SendTrackingRequest): Promise<any> {
        return this.client.sendTracking(req);
    }

    get openCommandStream() {
        return this.client.openCommandStream?.bind(this.client);
    }
}
